/**
 * Load-more pagination (DC Cycles).
 * Appends the next page's product cards to #product-grid instead of paging.
 * Progressive enhancement over the standard pagination links: the numbered
 * pagination is rendered inside a <noscript> fallback by the snippet.
 * Re-initialises automatically when facets.js re-renders the grid container.
 */
class DcLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.js-dc-load-more-button');
    this.progress = this.querySelector('.js-dc-load-more-progress');
    if (!this.button) return;
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  async onClick(event) {
    event.preventDefault();
    const url = this.button.getAttribute('data-next-url');
    if (!url) return;

    this.button.setAttribute('aria-busy', 'true');
    this.button.classList.add('is-loading');

    try {
      const response = await fetch(url);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const currentGrid = document.querySelector('#product-grid');
      if (newGrid && currentGrid) {
        newGrid.querySelectorAll(':scope > .grid-item').forEach((item) => {
          currentGrid.appendChild(item);
        });
      }

      const nextLoadMore = doc.querySelector('dc-load-more .js-dc-load-more-button');
      const nextUrl = nextLoadMore && nextLoadMore.getAttribute('data-next-url');
      if (nextUrl) {
        this.button.setAttribute('data-next-url', nextUrl);
      } else {
        this.button.hidden = true;
      }

      if (this.progress) {
        const total = parseInt(this.getAttribute('data-total'), 10);
        const shown = document.querySelectorAll(
          '#product-grid > .grid-item:not(.grid-item-block)'
        ).length;
        const template = this.getAttribute('data-progress-template') || '';
        this.progress.textContent = template
          .replace('[[shown]]', Math.min(shown, total))
          .replace('[[total]]', total);
      }
    } catch (error) {
      // On any failure fall back to a full page load of the next page
      window.location.href = url;
    } finally {
      this.button.removeAttribute('aria-busy');
      this.button.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('dc-load-more')) {
  customElements.define('dc-load-more', DcLoadMore);
}
